import React, { Component } from 'react'
import Dialog from '@material-ui/core/Dialog'
import DialogTitle from '@material-ui/core/DialogTitle'
import DialogContent from '@material-ui/core/DialogContent'
import DialogActions from '@material-ui/core/DialogActions'
import Button from '@material-ui/core/Button'
import TextField from '@material-ui/core/TextField'
import FormControl from '@material-ui/core/FormControl'
import FormLabel from '@material-ui/core/FormLabel'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import Radio from '@material-ui/core/Radio'
import RadioGroup from '@material-ui/core/RadioGroup'
import Typography from '@material-ui/core/Typography'
import IconButton from '@material-ui/core/IconButton'
import Icon from '@mdi/react'
import { mdiPencil, mdiDelete, mdiPlus } from '@mdi/js'
import { t } from '../i18n'
import { UDV_SURFACE, udvDialogProps } from './udvSurface'
import {
  listScpDestinations,
  upsertScpDestination,
  removeScpDestination,
  SCP_CONNECTOR_STOW,
  SCP_CONNECTOR_ORTHANC,
  SCP_CONNECTOR_CSTORE,
  connectorLabelKey,
} from '../utils/scpDestinations'

const emptyForm = () => ({
  id: '',
  name: '',
  connector: SCP_CONNECTOR_STOW,
  IP: '',
  PUERTO: '443',
  PROTOCOLO: 'https',
  BASE_PATH: '',
  USUARIO: '',
  PASS: '',
  DICOMWEB_BASE: '/dicom-web',
  AETITLE: '',
})

/**
 * CRUD de destinos SCP de usuario (STOW-RS / Orthanc REST).
 */
class ScpDestinationsDlg extends Component {
  state = {
    list: listScpDestinations(),
    editing: false,
    form: emptyForm(),
    error: '',
  }

  refresh = () => {
    this.setState({ list: listScpDestinations() })
    if (typeof this.props.onChange === 'function') {
      this.props.onChange(listScpDestinations())
    }
  }

  startAdd = () => {
    this.setState({ editing: true, form: emptyForm(), error: '' })
  }

  startEdit = (dest) => {
    this.setState({
      editing: true,
      error: '',
      form: {
        ...emptyForm(),
        ...dest,
      },
    })
  }

  cancelEdit = () => {
    this.setState({ editing: false, form: emptyForm(), error: '' })
  }

  setField = (key, value) => {
    this.setState((prev) => ({
      form: { ...prev.form, [key]: value },
      error: '',
    }))
  }

  save = () => {
    const { form } = this.state
    if (form.connector === SCP_CONNECTOR_CSTORE) {
      this.setState({ error: t('scpDlg.errorCstore') })
      return
    }
    const saved = upsertScpDestination(form)
    if (!saved) {
      this.setState({ error: t('scpDlg.errorInvalid') })
      return
    }
    this.setState({ editing: false, form: emptyForm(), error: '' })
    this.refresh()
  }

  remove = (id) => {
    if (!window.confirm(t('scpDlg.confirmDelete'))) return
    removeScpDestination(id)
    this.refresh()
  }

  renderForm() {
    const { form, error } = this.state
    const fieldSx = { marginBottom: 10 }
    return (
      <div>
        <TextField
          fullWidth
          size="small"
          label={t('scpDlg.name')}
          value={form.name}
          onChange={(e) => this.setField('name', e.target.value)}
          style={fieldSx}
          InputLabelProps={{ style: UDV_SURFACE.muted }}
          InputProps={{ style: { color: '#e8eef4' } }}
        />
        <FormControl component="fieldset" style={{ marginBottom: 12 }}>
          <FormLabel style={{ ...UDV_SURFACE.muted, fontSize: '0.8rem' }}>
            {t('scpDlg.connector')}
          </FormLabel>
          <RadioGroup
            value={form.connector}
            onChange={(e) => this.setField('connector', e.target.value)}
          >
            <FormControlLabel
              value={SCP_CONNECTOR_STOW}
              control={<Radio size="small" style={{ color: '#64b5f6' }} />}
              label={t('scpDlg.connectorStow')}
              style={{ color: '#e8eef4' }}
            />
            <FormControlLabel
              value={SCP_CONNECTOR_ORTHANC}
              control={<Radio size="small" style={{ color: '#64b5f6' }} />}
              label={t('scpDlg.connectorOrthanc')}
              style={{ color: '#e8eef4' }}
            />
            <FormControlLabel
              value={SCP_CONNECTOR_CSTORE}
              disabled
              control={<Radio size="small" />}
              label={t('scpDlg.connectorCstore')}
              style={{ color: 'rgba(180,195,210,0.5)' }}
            />
          </RadioGroup>
          <Typography variant="caption" style={{ ...UDV_SURFACE.muted, display: 'block' }}>
            {t('scpDlg.cstoreHint')}
          </Typography>
        </FormControl>
        <TextField
          fullWidth
          size="small"
          label={t('scpDlg.host')}
          value={form.IP}
          onChange={(e) => this.setField('IP', e.target.value)}
          style={fieldSx}
          InputLabelProps={{ style: UDV_SURFACE.muted }}
          InputProps={{ style: { color: '#e8eef4' } }}
        />
        <div style={{ display: 'flex', gap: 8 }}>
          <TextField
            size="small"
            label={t('scpDlg.port')}
            value={form.PUERTO}
            onChange={(e) => this.setField('PUERTO', e.target.value)}
            style={{ ...fieldSx, flex: 1 }}
            InputLabelProps={{ style: UDV_SURFACE.muted }}
            InputProps={{ style: { color: '#e8eef4' } }}
          />
          <FormControl style={{ flex: 1, marginBottom: 10 }}>
            <FormLabel style={{ ...UDV_SURFACE.muted, fontSize: '0.75rem' }}>
              {t('scpDlg.protocol')}
            </FormLabel>
            <RadioGroup
              row
              value={form.PROTOCOLO}
              onChange={(e) => this.setField('PROTOCOLO', e.target.value)}
            >
              <FormControlLabel
                value="https"
                control={<Radio size="small" style={{ color: '#64b5f6' }} />}
                label="HTTPS"
                style={{ color: '#e8eef4' }}
              />
              <FormControlLabel
                value="http"
                control={<Radio size="small" style={{ color: '#64b5f6' }} />}
                label="HTTP"
                style={{ color: '#e8eef4' }}
              />
            </RadioGroup>
          </FormControl>
        </div>
        <TextField
          fullWidth
          size="small"
          label={t('scpDlg.basePath')}
          value={form.BASE_PATH}
          onChange={(e) => this.setField('BASE_PATH', e.target.value)}
          placeholder="/visorweb"
          style={fieldSx}
          InputLabelProps={{ style: UDV_SURFACE.muted }}
          InputProps={{ style: { color: '#e8eef4' } }}
        />
        {form.connector === SCP_CONNECTOR_STOW ? (
          <TextField
            fullWidth
            size="small"
            label={t('scpDlg.dicomWebBase')}
            value={form.DICOMWEB_BASE}
            onChange={(e) => this.setField('DICOMWEB_BASE', e.target.value)}
            style={fieldSx}
            InputLabelProps={{ style: UDV_SURFACE.muted }}
            InputProps={{ style: { color: '#e8eef4' } }}
          />
        ) : null}
        <TextField
          fullWidth
          size="small"
          label={t('scpDlg.aeTitle')}
          value={form.AETITLE}
          onChange={(e) => this.setField('AETITLE', e.target.value)}
          style={fieldSx}
          InputLabelProps={{ style: UDV_SURFACE.muted }}
          InputProps={{ style: { color: '#e8eef4' } }}
        />
        <TextField
          fullWidth
          size="small"
          label={t('scpDlg.user')}
          value={form.USUARIO}
          onChange={(e) => this.setField('USUARIO', e.target.value)}
          style={fieldSx}
          InputLabelProps={{ style: UDV_SURFACE.muted }}
          InputProps={{ style: { color: '#e8eef4' } }}
          autoComplete="off"
        />
        <TextField
          fullWidth
          size="small"
          type="password"
          label={t('scpDlg.password')}
          value={form.PASS}
          onChange={(e) => this.setField('PASS', e.target.value)}
          style={fieldSx}
          InputLabelProps={{ style: UDV_SURFACE.muted }}
          InputProps={{ style: { color: '#e8eef4' } }}
          autoComplete="new-password"
        />
        {error ? (
          <Typography variant="body2" style={{ color: '#ff8a80', marginTop: 4 }}>
            {error}
          </Typography>
        ) : null}
      </div>
    )
  }

  renderList() {
    const { list } = this.state
    if (!list.length) {
      return (
        <Typography variant="body2" style={UDV_SURFACE.muted}>
          {t('scpDlg.empty')}
        </Typography>
      )
    }
    return list.map((d) => (
      <div
        key={d.id}
        style={{
          ...UDV_SURFACE.listItem,
          display: 'flex',
          alignItems: 'center',
          padding: '8px 10px',
          gap: 8,
        }}
      >
        <div style={{ flex: 1, minWidth: 0 }}>
          <div style={{ fontWeight: 600, fontSize: '0.9rem' }}>{d.name}</div>
          <div style={{ fontSize: '0.75rem', opacity: 0.7 }}>
            {t(connectorLabelKey(d.connector))} · {d.PROTOCOLO}://{d.IP}:{d.PUERTO}
            {d.BASE_PATH || ''}
          </div>
        </div>
        <IconButton size="small" onClick={() => this.startEdit(d)} title={t('common.ok')}>
          <Icon path={mdiPencil} size={0.75} color="#90caf9" />
        </IconButton>
        <IconButton size="small" onClick={() => this.remove(d.id)} title={t('scpDlg.delete')}>
          <Icon path={mdiDelete} size={0.75} color="#ff8a80" />
        </IconButton>
      </div>
    ))
  }

  render() {
    const { open, onClose } = this.props
    const { editing } = this.state

    return (
      <Dialog open={!!open} onClose={onClose} fullWidth maxWidth="sm" {...udvDialogProps}>
        <DialogTitle style={UDV_SURFACE.title}>
          {editing ? t('scpDlg.editTitle') : t('scpDlg.title')}
        </DialogTitle>
        <DialogContent style={UDV_SURFACE.content}>
          {editing ? this.renderForm() : this.renderList()}
        </DialogContent>
        <DialogActions style={UDV_SURFACE.actions}>
          {editing ? (
            <>
              <Button onClick={this.cancelEdit} style={UDV_SURFACE.btnGhost}>
                {t('common.cancel')}
              </Button>
              <Button onClick={this.save} style={UDV_SURFACE.btnPrimary} variant="contained">
                {t('scpDlg.save')}
              </Button>
            </>
          ) : (
            <>
              <Button onClick={onClose} style={UDV_SURFACE.btnGhost}>
                {t('common.close')}
              </Button>
              <Button
                onClick={this.startAdd}
                style={UDV_SURFACE.btnPrimary}
                variant="contained"
                startIcon={<Icon path={mdiPlus} size={0.7} color="#fff" />}
              >
                {t('scpDlg.add')}
              </Button>
            </>
          )}
        </DialogActions>
      </Dialog>
    )
  }
}

export default ScpDestinationsDlg
